module.exports = __webpack_public_path__ + "static/media/Beaches_gif_tv.5bfcca58.gif";